import { initializeApp } from 'firebase/app';
import data from './assets/app-config.json';
import { getAuth } from 'firebase/auth';
import { LocalService } from './local.service';

export class FirebaseService {
  static app = initializeApp(data.FIREBASE_CONFIG);
  constructor() {}

  static getApp() {
    return this.app;
  }

  static async refreshToken() {
    const auth = getAuth(this.app);
    const tenantId = LocalService.getData('tenant_id');
    if (tenantId) auth.tenantId = tenantId;
    const userData = LocalService.getData('user_data');
    if (Math.floor(new Date(userData.expirationTime).getTime() - new Date().getTime()) / 60000 <= 10) {
      const apiKey = data.FIREBASE_CONFIG.apiKey;
      const body = `grant_type=refresh_token&refresh_token=${userData?.refreshToken}`;
      const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
      fetch(`https://securetoken.googleapis.com/v1/token?key=${apiKey}`, {
        method: 'POST',
        headers,
        body,
      })
        .then(response => response.json())
        .then(res => {
          if (!res.error) {
            userData.refreshToken = res.refresh_token;
            userData.accessToken = res.access_token;
            userData.expirationTime = new Date(userData.expirationTime + 60 * 60 * 1000).getTime();
            LocalService.saveData('user_data', JSON.stringify(userData));
          }
        })
        .catch(error => {
          // console.log(error);
        });
    }
  }
}
